import { useEffect } from "react";
import CopyButton from "./CopyButton";
import bottle from "../images/Message_In_A_Bottle.svg";

const Contact = () => {
  useEffect(() => {
    document.title = "Rest and Relax";
  }, []);

  return (
    <div className="flex flex-col items-center justify-center text-center text-secondary w-[80%] mx-auto">
      <h2 className="heading-xl">contact</h2>
      <img src={bottle} alt="logo" width="300" height="300" className="mb-2" />

      <p className="mb-8 md:mb-16 text-2xl md:text-5xl">
        for any questions or rental inquiries, please contact:
      </p>

      <div className="text-xl md:text-4xl text-black mb-8">
        <CopyButton text="veronica@restandrelaxvacation.com" />
      </div>
    </div>
  );
};

export default Contact;
